import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { useState, useEffect, useRef } from "react";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";

import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import '../../components/table.css';
import "../../components/mcrbTableTheme.css";
import styles from "../sellerlist/sellerList.module.css"

import Sellerpagination from "../../components/Paginated/Sellerpagination";
import { Link } from "react-router-dom";
const { apiEndpoint } = config;

var $ = require('jquery');

var count = 1;
const Issueslists = () => {
    const [sellerList, setSellerList] = useState([]);
    useEffect(() => {
        fetchIssueList();
    }, [])

    const fetchIssueList = async () => {
        
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/igm/get_reverseIssue`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
            });
            console.log("all data", data);
            setSellerList(data?.data)

        } catch (error) {
            console.log("error", error);

            // setIsLoading(false);
        }
    }

    console.log(sellerList)

    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row, count) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Issue Id",
            Footer: "Issue Id ",
            accessor: "issue_id",
            sticky: "left"
        },
        {
            Header: "Provider Id",
            Footer: "Provider Id",
            accessor: "ref_provider_id",
            sticky: "left"
        },
        {
            Header: "Transaction Id",
            Footer: "Transaction Id",
            accessor: "ref_transaction_id",
            sticky: "left"
        },
        {
            Header: "Level",
            Footer: "Level",
            accessor: "level",
            sticky: "left"
        },

        {
            Header: "Domain",
            Footer: "Domain",
            accessor: "domain",
            sticky: "left"
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: "status",
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row) => {
                
                return (
                    <>
                       <Link to={`../../raiseissue/${row.issue_id}`} className="btn btn-success btn-circle"> <i className="fas fa-eye"></i></Link>
                    </>
                )
            },
            sticky: "left"
        },


    ];
    count++

    const sellerDelete = async (id) => {
      

    }


    return (
        <>
            <ThemeMaker>

                <div className="mcrb-page">
                    <div className="mcrb-card">
                        <div className="mcrb-headbar">
                            <span>Ticket List</span>
                        </div>

                        <div className={`${styles.cardbody}`}>
                            <div className="table-responsive">
                                <div className={styles.sellerListing_desktop}>
                                    <Paginated data={sellerList} columns={COLUMNS} />
                                </div>
                                <div className={styles.sellerListing_mobile}>
                                    <Sellerpagination itemsPerPage={20} items={sellerList} sellerDelete={sellerDelete} paginationFor="seller"></Sellerpagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ThemeMaker>
        </>
    )
}

export default Issueslists;